import React, { useEffect, useState } from "react";
import { adminGetSettings, adminUpdateSettings } from "@/lib/adminApi";

export default function AdminContent() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => { adminGetSettings().then(setS).catch(() => {}); }, []);

  const setField = (k, v) => setS((prev) => ({ ...prev, [k]: v }));
  const setAnn = (key, i, v) => setS((prev) => { const arr = [...(prev[key] || ["", "", ""])]; arr[i] = v; return { ...prev, [key]: arr }; });

  const save = async () => {
    setSaving(true); setMsg(null);
    try {
      const updated = await adminUpdateSettings(s);
      setS(updated);
      setMsg({ type: "success", text: "Modifications enregistrées. Le site est mis à jour." });
    } catch (e) {
      setMsg({ type: "error", text: "Erreur lors de l'enregistrement" });
    }
    setSaving(false);
    setTimeout(() => setMsg(null), 4000);
  };

  if (!s) return <div className="adm-loader"><div className="spinner" /></div>;

  return (
    <div data-testid="admin-content">
      <div className="admin-topbar" style={{ marginBottom: "1.5rem" }}>
        <h1 className="admin-title">Contenu du site</h1>
        <button className="adm-btn" onClick={save} disabled={saving} data-testid="content-save">{saving ? "Enregistrement…" : "Enregistrer"}</button>
      </div>
      {msg ? <div className={`adm-msg ${msg.type}`} data-testid="content-msg">{msg.text}</div> : null}

      <div style={{ maxWidth: 720, display: "grid", gap: "2rem" }}>
        <section className="stat-card">
          <h3 style={{ fontFamily: "var(--serif)", color: "var(--emerald)", fontSize: "1.3rem", marginBottom: "1rem" }}>Livraison</h3>
          <div className="adm-row">
            <div className="adm-field"><label>Seuil livraison offerte (€)</label><input type="number" step="0.01" value={s.free_shipping_threshold} onChange={(e) => setField("free_shipping_threshold", parseFloat(e.target.value) || 0)} data-testid="set-threshold" /></div>
            <div className="adm-field"><label>Frais de livraison (€)</label><input type="number" step="0.01" value={s.shipping_fee} onChange={(e) => setField("shipping_fee", parseFloat(e.target.value) || 0)} data-testid="set-fee" /></div>
          </div>
        </section>

        <section className="stat-card">
          <h3 style={{ fontFamily: "var(--serif)", color: "var(--emerald)", fontSize: "1.3rem", marginBottom: "1rem" }}>Bandeau d'annonces (rotatif)</h3>
          {[0, 1, 2].map((i) => (
            <div className="adm-field" key={i} style={{ marginBottom: "0.8rem" }}>
              <label>Message {i + 1} (FR)</label>
              <input value={(s.announcements || [])[i] || ""} onChange={(e) => setAnn("announcements", i, e.target.value)} data-testid={`set-ann-${i}`} />
            </div>
          ))}
          {[0, 1, 2].map((i) => (
            <div className="adm-field" key={`nl${i}`} style={{ marginBottom: "0.8rem" }}>
              <label>Message {i + 1} (NL)</label>
              <input value={(s.announcements_nl || [])[i] || ""} onChange={(e) => setAnn("announcements_nl", i, e.target.value)} />
            </div>
          ))}
        </section>

        <section className="stat-card">
          <h3 style={{ fontFamily: "var(--serif)", color: "var(--emerald)", fontSize: "1.3rem", marginBottom: "1rem" }}>Hero (page d'accueil)</h3>
          <div className="adm-field"><label>Sur-titre (FR)</label><input value={s.hero_eyebrow || ""} onChange={(e) => setField("hero_eyebrow", e.target.value)} data-testid="set-hero-eyebrow" /></div>
          <div className="adm-field"><label>Titre (FR)</label><input value={s.hero_title || ""} onChange={(e) => setField("hero_title", e.target.value)} data-testid="set-hero-title" /></div>
          <div className="adm-field"><label>Sous-titre (FR)</label><textarea rows={2} value={s.hero_subtitle || ""} onChange={(e) => setField("hero_subtitle", e.target.value)} /></div>
          <div className="adm-field"><label>Sur-titre (NL)</label><input value={s.hero_eyebrow_nl || ""} onChange={(e) => setField("hero_eyebrow_nl", e.target.value)} /></div>
          <div className="adm-field"><label>Titre (NL)</label><input value={s.hero_title_nl || ""} onChange={(e) => setField("hero_title_nl", e.target.value)} /></div>
          <div className="adm-field"><label>Sous-titre (NL)</label><textarea rows={2} value={s.hero_subtitle_nl || ""} onChange={(e) => setField("hero_subtitle_nl", e.target.value)} /></div>
        </section>
        <section className="stat-card">
          <h3 style={{ fontFamily: "var(--serif)", color: "var(--emerald)", fontSize: "1.3rem", marginBottom: "1rem" }}>Suivi & Analytics (cookies)</h3>
          <p style={{ fontSize: "0.8rem", color: "var(--muted)", marginBottom: "1rem" }}>
            Les scripts ne se chargent que si la visiteuse accepte la bannière cookies. Laissez vide pour désactiver.
          </p>
          <div className="adm-row">
            <div className="adm-field"><label>ID Google Analytics 4 (G-XXXXXXX)</label><input value={s.ga4_id || ""} onChange={(e) => setField("ga4_id", e.target.value.trim())} data-testid="set-ga4" placeholder="G-XXXXXXXXXX" /></div>
            <div className="adm-field"><label>ID Meta Pixel</label><input value={s.meta_pixel_id || ""} onChange={(e) => setField("meta_pixel_id", e.target.value.trim())} data-testid="set-pixel" placeholder="123456789012345" /></div>
          </div>
        </section>
      </div>
    </div>
  );
}
